import React from "react";
import { withTranslation } from "react-i18next";
import { FiTrendingUp } from "react-icons/fi";
import "./ModernEmptyGraphCard.scss";

const ModernEmptyGraphCard = ({ t, graphConfig = false }) => {
  if (graphConfig) {
    return (
      <div className="modern-no-configs-card" data-testid="modern-empty-graph-card">
        <div className="modern-no-configs-content">
          <div className="modern-no-configs-icon">
            <FiTrendingUp />
          </div>
          <h6 className="modern-no-configs-title">{t('NoGraphsConfigured.label')}</h6>
          <p className="modern-no-configs-description">
            {t('ModernEmptyGraphCard.noGraphsDescription.label')}
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="modern-no-data-container" data-testid="modern-no-data-message">
        <p className="modern-no-data-text">{t('NoDataAvailable.label')}</p>
      </div>
    );
  }
};

export default withTranslation()(ModernEmptyGraphCard); 